module.exports = __webpack_public_path__ + "img/icon_sb_shipping_16x16_v2.7b9aee9.svg";